module.exports = __webpack_public_path__ + "img/t-1.a6fabaa1.png";